import React from 'react';
import StarRatings from 'react-star-ratings';

const RatingComponent = ({
  rating,
  onChange,
  numberOfStars = 5,
  name = 'rate1',
  starRatedColor = 'rgb(255, 180, 0)',
  starEmptyColor = 'rgb(51, 51, 51)',
  starHoverColor = 'rgb(255, 180, 0)',
  starDimension = '20px',
  starSpacing = '2px',
}) => {
  return (
    <StarRatings
      rating={rating}
      starRatedColor={starRatedColor}
      starEmptyColor={starEmptyColor}
      starHoverColor={starHoverColor}
      starDimension={starDimension}
      starSpacing={starSpacing}
      changeRating={onChange}
      numberOfStars={numberOfStars}
      name={name}
    />
  );
};

export default RatingComponent;



// WEBPACK FOOTER //
// ./src/Components-2025/RatingComponent.js